import {
    AOS_MANUT_VEICULO_ABERTA,
    AOS_MANUT_VEICULO_FECHADA,
    AOS_MANUT_VEICULO_CANCELADA
} from 'consts';
import {
    buildListParams,
    getListData,
    getTotalRecords,
    handleListIconMouseEnter,
    handleListIconMouseLeave,
    listStyles,
    loadStoredJson,
    removeStoredKeys,
    saveStoredValue
} from 'lib/listUtils';
import {
    Button,
    Card,
    CardContent,
    Input,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip
} from '@material-ui/core';
import {
    BackspaceOutlined as BackspaceOutlinedIcon,
    EditTwoTone as EditTwoToneIcon,
    Search as SearchIcon,
    VisibilityOutlined as VisibilityOutlinedIcon
} from '@material-ui/icons';
import api from 'services/api';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import { formatData } from 'lib/functions';
import PerfectScrollbar from 'react-perfect-scrollbar';
import AlertInformation from 'components/AlertInformation/AlertInformation';

class OsManutVeiculoList extends Component {
    state = {
        searchFilter: loadStoredJson('osmanutveiculoSearchFilter', {
            nroveiculo: '',
            situacao: AOS_MANUT_VEICULO_ABERTA
        }),
        ossmanutveiculos: [],
        openAlert: false,
        messageAlert: '',
        totalItems: 0,
        page: Number(sessionStorage.getItem('osmanutveiculoPage')) || 0,
        rowsPerPage: Number(sessionStorage.getItem('osmanutveiculoRowsPerPage')) || 10
    };

    estilo = listStyles;

    handleIconMouseEnter = handleListIconMouseEnter;
    handleIconMouseLeave = handleListIconMouseLeave;

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this.loadOssManutVeiculo();
    };

    /* Paginação */
    componentDidUpdate(prevProps, prevState) {
        const { page, rowsPerPage, searchFilter } = this.state;

        // persiste os filtros e a paginação no sessionStorage
        if (prevState.searchFilter !== searchFilter) {
            saveStoredValue('osmanutveiculoSearchFilter', searchFilter);
        }

        if (prevState.page !== page) {
            saveStoredValue('osmanutveiculoPage', page);
        }

        if (prevState.rowsPerPage !== rowsPerPage) {
            saveStoredValue('osmanutveiculoRowsPerPage', rowsPerPage);
        }
    };

    /* Limpa os filtros e a paginação ao sair da tela */
    componentWillUnmount() {
        removeStoredKeys([
            'osmanutveiculoSearchFilter',
            'osmanutveiculoPage',
            'osmanutveiculoRowsPerPage'
        ]);
    };

    /* Carrega as OSs de manutenção de veículo */
    loadOssManutVeiculo = async () => {
        const { page, rowsPerPage, searchFilter } = this.state;
        const { nroveiculo, situacao } = searchFilter;

        const params = buildListParams({
            page,
            rowsPerPage,
            filters: [
                {
                    field: 'NROVEICULO',
                    value: nroveiculo,
                    operator: '_like_'
                },
                {
                    field: 'SITUACAO',
                    value: situacao
                }
            ]
        });

        try {
            const response = await api.get('/osmanutveiculo' + params);

            this.setState({
                ossmanutveiculos: getListData(response),
                totalItems: getTotalRecords(response)
            });
        } catch (error) {
            console.error('Erro ao carregar OSs de manutenção de veículo:', error);

            this.setState({
                ossmanutveiculos: [],
                totalItems: 0
            });
        }
    };

    /* Muda a página */
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, this.loadOssManutVeiculo);
    };

    /* Muda a quantidade de retornos por página */
    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        }, this.loadOssManutVeiculo);
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Pesquisa os filtros na tela */
    onChangeSearch = (event) => {
        const { checked, name, type, value } = event.target;
        const searchFilter = { ...this.state.searchFilter };

        if (type === 'checkbox') {
            searchFilter[name] = checked;
        } else {
            searchFilter[name] = (typeof value === 'string') ? value.toUpperCase() : value;
        }

        this.setState({
            searchFilter,
            page: 0
        });
    };

    /* Limpa os filtros da tela */
    limpaFiltros = () => {
        const searchFilter = {
            nroveiculo: '',
            situacao: AOS_MANUT_VEICULO_ABERTA
        };

        this.setState({
            searchFilter,
            page: 0
        }, this.loadOssManutVeiculo);
    };

    render() {
        const {
            ossmanutveiculos,
            searchFilter,
            openAlert,
            messageAlert,
            totalItems,
            page,
            rowsPerPage
        } = this.state;

        const {
            actionIcon,
            addButton,
            filterPaper,
            iconGroup,
            redText
        } = this.estilo;

        return (
            <div style={this.estilo}>
                <Paper
                    hover
                    fullWidth
                    style={filterPaper}
                >
                    <Input
                        autoFocus
                        id="nroveiculo"
                        name="nroveiculo"
                        onChange={this.onChangeSearch}
                        placeholder="Veículo"
                        value={searchFilter.nroveiculo}
                        style={{
                            flex: '0 1 200px',
                            minWidth: 200
                        }}
                    />

                    <Select
                        id="situacao"
                        name="situacao"
                        value={searchFilter.situacao || ''}
                        onChange={this.onChangeSearch}
                        style={{
                            flex: '0 1 100px',
                            minWidth: 100,
                            textAlign: 'center'
                        }}
                    >
                        <MenuItem
                            value={AOS_MANUT_VEICULO_ABERTA}
                            style={{ justifyContent: 'center' }}
                        >
                            Abertas
                        </MenuItem>

                        <MenuItem
                            value={AOS_MANUT_VEICULO_CANCELADA}
                            style={{ justifyContent: 'center' }}
                        >
                            Canceladas
                        </MenuItem>

                        <MenuItem
                            value={AOS_MANUT_VEICULO_FECHADA}
                            style={{ justifyContent: 'center' }}
                        >
                            Encerradas
                        </MenuItem>

                        <MenuItem
                            value={'T'}
                            style={{ justifyContent: 'center' }}
                        >
                            Todas
                        </MenuItem>
                    </Select>

                    <span style={iconGroup}>
                        <Tooltip title="Procurar">
                            <SearchIcon
                                onClick={this.loadOssManutVeiculo}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>

                        <Tooltip title="Limpar">
                            <BackspaceOutlinedIcon
                                onClick={this.limpaFiltros}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>
                    </span>

                    <div style={{ flex: 1 }} />

                    <Button
                        component={Link}
                        to="/frotas/osmanutveiculo/novo"
                        variant="contained"
                        color="primary"
                        style={addButton}
                    >
                        Novo
                    </Button>
                </Paper>

                <br />

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Código</TableCell>

                                            <TableCell align="center">Descrição</TableCell>

                                            <TableCell align="center">Data Emissão</TableCell>

                                            <TableCell align="center">Ações</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {ossmanutveiculos.length === 0 && (
                                            <TableRow>
                                                <TableCell
                                                    align="center"
                                                    colSpan={4}
                                                >
                                                    Nenhuma OS de manutenção de veículo encontrada
                                                </TableCell>
                                            </TableRow>
                                        )}

                                        {ossmanutveiculos.map(osmanutveiculo => (
                                            <TableRow
                                                hover
                                                key={osmanutveiculo.codosmanutveiculo}
                                            >
                                                <TableCell
                                                    align="center"
                                                    style={(osmanutveiculo.situacao === AOS_MANUT_VEICULO_CANCELADA) ? redText : {}}
                                                >
                                                    {osmanutveiculo.codosmanutveiculo}
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={(osmanutveiculo.situacao === AOS_MANUT_VEICULO_CANCELADA) ? redText : {}}
                                                >
                                                    {osmanutveiculo.nroveiculo}
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={(osmanutveiculo.situacao === AOS_MANUT_VEICULO_CANCELADA) ? redText : {}}
                                                >
                                                    {formatData(osmanutveiculo.dataemissao)}
                                                </TableCell>

                                                <TableCell align="center">
                                                    <span style={iconGroup}>
                                                        <Tooltip title="Editar">
                                                            <Link to={`/frotas/osmanutveiculo/${osmanutveiculo.codosmanutveiculo}`}>
                                                                <EditTwoToneIcon
                                                                    onMouseEnter={this.handleIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Link>
                                                        </Tooltip>

                                                        <Tooltip title="Visualizar">
                                                            <Link to={`/frotas/osmanutveiculo/${osmanutveiculo.codosmanutveiculo}/view`}>
                                                                <VisibilityOutlinedIcon
                                                                    onMouseEnter={this.handleIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Link>
                                                        </Tooltip>
                                                    </span>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>

                        <TablePagination
                            component="div"
                            count={totalItems}
                            onPageChange={this.handleChangePage}
                            page={page}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                            rowsPerPage={rowsPerPage}
                            rowsPerPageOptions={[10, 50, 100, 200]}
                            labelRowsPerPage="Registros por página"
                        />
                    </CardContent>
                </Card>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

export default OsManutVeiculoList;